import * as Yup from 'yup'
import { EmailPreferenceItem } from './EmailPreferenceOrder'

export interface FormValues {
    subject: string
    jobBoard?: boolean
    name?: string
    description?: string
    titles?: DropdownOption[] | []
    locations?: DropdownOption[] | []
    sectors?: DropdownOption[] | []
    startDate?: string
    emailPreferenceOrder: EmailPreferenceItem[]
}

interface DropdownOption {
    id: string
    value: string
}

export const validationSchema: Yup.ObjectSchema<FormValues> = Yup.object({
    subject: Yup.string().nonNullable().required('Subject is required'),
    jobBoard: Yup.boolean(),
    emailPreferenceOrder: Yup.array()
        .of(
            Yup.object({
                preference: Yup.string()
                    .oneOf(['preferred', 'personal', 'work'])
                    .required(),
                enabled: Yup.boolean().required(),
            }).required()
        )
        .test(
            'at-least-one-enabled',
            'At least one email preference must be enabled',
            (value) => {
                return value ? value.some((item) => item.enabled) : false
            }
        )
        .required(),
    name: Yup.string().when('jobBoard', {
        is: (jobBoard) => Boolean(jobBoard),
        then: (schema) => schema.required('Name is required'),
    }),
    description: Yup.string().when('jobBoard', {
        is: (jobBoard) => Boolean(jobBoard),
        then: (schema) => schema.required('Description is required'),
    }),
    titles: Yup.array()
        .of(
            Yup.object()
                .shape({
                    id: Yup.string().required(),
                    value: Yup.string().required(),
                })
                .required()
        )
        .when('jobBoard', {
            is: (jobBoard) => Boolean(jobBoard),
            then: (schema) => schema.min(1, 'Titles are required'),
        }),
    sectors: Yup.array()
        .of(
            Yup.object()
                .shape({
                    id: Yup.string().required(),
                    value: Yup.string().required(),
                })
                .required()
        )
        .when('jobBoard', {
            is: (jobBoard) => Boolean(jobBoard),
            then: (schema) => schema.min(1, 'Sectors are required'),
        }),
    locations: Yup.array()
        .of(
            Yup.object()
                .shape({
                    id: Yup.string().required(),
                    value: Yup.string().required(),
                })
                .required()
        )
        .when('jobBoard', {
            is: (jobBoard) => Boolean(jobBoard),
            then: (schema) => schema.min(1, 'Locations are required'),
        }),
    startDate: Yup.string(),
})

export const initialValues: FormValues = {
    subject: '',
    jobBoard: false,
    name: '',
    description: '',
    titles: [],
    locations: [],
    sectors: [],
    startDate: '',
    emailPreferenceOrder: [
        { preference: 'preferred', enabled: true },
        { preference: 'personal', enabled: true },
        { preference: 'work', enabled: true },
    ] as EmailPreferenceItem[],
}
